import { useMutation } from "react-query";
import { zendeskApiRequest } from "./zendesk-client";
const fetchZendeskUpload = (file) => {
  return zendeskApiRequest({
    url: `/api/v2/uploads?filename=${file.name}`,
    method: "POST",
    headers: {
      "Content-Type": file.type
    },
    data: file
  });
};
function useZendeskMutation() {
  return useMutation({
    mutationFn: ({ file }) => fetchZendeskUpload(file)
  });
}
export {
  fetchZendeskUpload,
  useZendeskMutation
};
